import { render, staticRenderFns } from "./QuarterResourceReportDetails.vue?vue&type=template&id=48d55c42&scoped=true&"
import script from "./QuarterResourceReportDetails.vue?vue&type=script&lang=js&"
export * from "./QuarterResourceReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuarterResourceReportDetails.vue?vue&type=style&index=0&id=48d55c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d55c42",
  null
  
)

export default component.exports